module.exports = __webpack_public_path__ + "static/media/instagram.f9d5adc8.png";